import api from "./api";
import {
  RoleSwitchRulesResponse,
  SaveRoleSwitchRulesPayload,
} from "../types/RoleSwitchRule";

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("authToken");

  if (!token) {
    throw new Error("Token não encontrado");
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};

export async function findRoleSwitchRules(
  sourceRoleId: number,
): Promise<RoleSwitchRulesResponse> {
  const response = await api.get<RoleSwitchRulesResponse>("/role-switch-rules", {
    params: {
      source_role_id: sourceRoleId,
    },
    headers: getAuthHeaders(),
  });

  return response.data;
}

export async function saveRoleSwitchRules(
  payload: SaveRoleSwitchRulesPayload,
): Promise<void> {
  await api.post("/role-switch-rules", payload, {
    headers: getAuthHeaders(),
  });
}
